import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
// action types
export const UPDATE_TABLE_STRUCTURE = "getCUSTOMTableStructure";
export const UPDATE_TABLE_DATA = "getCUSTOMTableData";
export const UPDATE_CREATE_DATA = "getCUSTOMCreateData";
export const EXPORT_TABLE_DATA = "getCUSTOMEXPORTTABLEDATA";

// mutation types
export const SET_TABLE_STRUCTURE = "setCUSTOMTableStructure";
export const SET_TABLE_DATA = "setCUSTOMTableData";
export const SET_TABLE_FILTER = "setCUSTOMTableFilter";
export const SET_TABLE_PAGE = "setCUSTOMTablePage";
export const SET_TABLE_PERPAGE = "setCUSTOMTablePerPage";
export const SET_TABLE_SORTBY = "setCUSTOMTableSortBy";
export const SET_TABLE_SORTORDER = "setCUSTOMTableSortOrder";
export const SET_CREATE_DATA = "setCUSTOMCreateData";
export const SET_EXPORT_LINK = "setCUSTOMExportLink";

const state = {
  table_structure: {},
  create_data: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
  export_link: null,
};

const getters = {
  getCUSTOMTableState(state) {
    return state.table_state;
  },

  getCUSTOMTableHeaders(state) {
    return state.table_structure.columns;
  },

  getCUSTOMTableFilters(state) {
    return state.table_structure.filters;
  },

  getCUSTOMTablePermissions(state) {
    return state.table_structure.permissions;
  },

  getCUSTOMTableData(state) {
    return state.table_data.data;
  },

  getCUSTOMCreateData(state) {
    return state.create_data;
  },

  getCUSTOMTableProperties(state) {
    return state.table_structure.properties;
  },

  getCUSTOMExportUrl(state) {
    return state.export_link;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/pages")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/pages/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_CREATE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/pages/create", payload)
        .then(({ data }) => {
          context.commit(SET_CREATE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/stores/portal/pages/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_CREATE_DATA](state, create_data) {
    state.create_data = create_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
